export default "__VITE_ASSET__CvSHbo5l__"